import { render, staticRenderFns } from "./PDPDiscussion.vue?vue&type=template&id=62f45f86&scoped=true&"
import script from "./PDPDiscussion.vue?vue&type=script&lang=js&"
export * from "./PDPDiscussion.vue?vue&type=script&lang=js&"
import style0 from "./PDPDiscussion.vue?vue&type=style&index=0&id=62f45f86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f45f86",
  null
  
)

export default component.exports